module.exports = __webpack_public_path__ + "img/error.db28d105.jpeg";